import { Modal, ModalProps } from 'antd';
import classnames from 'classnames';
import styled from 'styled-components';

function DpModalBase(props: ModalProps) {
  return (
    <Modal {...props} className={classnames('with-padding', props.className)}>
      {props.children}
    </Modal>
  );
}

export default styled(DpModalBase)`
  .next-antd-modal-content {
    padding: 32px;
  }

  .next-antd-modal-header {
    margin-bottom: 18px;
    font-size: 20px;
    color: #0c0c0c;
  }

  .next-antd-modal-footer {
    display: flex;
    gap: 8px;
    margin-top: 26px;

    @media (max-width: 768px) {
      flex-direction: column;
      min-height: 92px;
    }

    .next-antd-btn {
      flex: 1;
      height: 42px;
      font-weight: 700;
      font-size: 16px;
      border-radius: 999px;
      margin: 0 !important;
    }
  }
`;
